function getRotation(element) {
	var style = window.getComputedStyle(element, null);
	
	var transform = style.getPropertyValue("-webkit-transform") || style.getPropertyValue("-moz-transform") || style.getPropertyValue("-ms-transform") || style.getPropertyValue("-o-transform") || style.getPropertyValue("transform");

	if(!transform) {
		return false;
	}

	var values = transform.split('(')[1];
    values = values.split(')')[0];
    values = values.split(',');

	var radians = Math.atan2(values[1], values[0]);
	if (radians < 0) {
		radians += (2 * Math.PI);
	}
	var angle = Math.round( radians * (180/Math.PI));
	return angle;
}

function updateProgress(uploader, progress, animate) {
	animate = typeof animate !== 'undefined' ? animate : true;
	progress = progress * 3.6;
	
	if(animate) {
		uploader.addClass('animate');
	} else {
		uploader.removeClass('animate');
	}

	var interval;
	interval = setInterval(function() {
		var four = getRotation(uploader.find('.four')[0]);
		var one = getRotation(uploader.find('.one')[0]);

		uploader.find('.progress-overlay').hide();

		if(one < 90) {
			uploader.find('.progress-overlay').show();
		}

		if(four === progress) {
			clearInterval(interval);
		}
	}, 10);

	if(progress <= 90) {

		uploader.find('.one').css({
			'-webkit-transform': 'rotate('+progress+'deg)',
			'-moz-transform': 'rotate('+progress+'deg)',
			'-ms-transform': 'rotate('+progress+'deg)',
			'transform': 'rotate('+progress+'deg)'
		});

		uploader.find('.two').css({
			'-webkit-transform': 'rotate('+progress+'deg)',
			'-moz-transform': 'rotate('+progress+'deg)',
			'-ms-transform': 'rotate('+progress+'deg)',
			'transform': 'rotate('+progress+'deg)'
		});

		uploader.find('.three').css({
			'-webkit-transform': 'rotate('+progress+'deg)',
			'-moz-transform': 'rotate('+progress+'deg)',
			'-ms-transform': 'rotate('+progress+'deg)',
			'transform': 'rotate('+progress+'deg)'
		});

		uploader.find('.four').css({
			'-webkit-transform': 'rotate('+progress+'deg)',
			'-moz-transform': 'rotate('+progress+'deg)',
			'-ms-transform': 'rotate('+progress+'deg)',
			'transform': 'rotate('+progress+'deg)'
		});

		return false;
	}

	if(progress <= 180) {

		uploader.find('.one').css({
			'-webkit-transform': 'rotate(90deg)',
			'-moz-transform': 'rotate(90deg)',
			'-ms-transform': 'rotate(90deg)',
			'transform': 'rotate(90deg)'
		});

		uploader.find('.two').css({
			'-webkit-transform': 'rotate('+progress+'deg)',
			'-moz-transform': 'rotate('+progress+'deg)',
			'-ms-transform': 'rotate('+progress+'deg)',
			'transform': 'rotate('+progress+'deg)'
		});

		uploader.find('.three').css({
			'-webkit-transform': 'rotate('+progress+'deg)',
			'-moz-transform': 'rotate('+progress+'deg)',
			'-ms-transform': 'rotate('+progress+'deg)',
			'transform': 'rotate('+progress+'deg)'
		});

		uploader.find('.four').css({
			'-webkit-transform': 'rotate('+progress+'deg)',
			'-moz-transform': 'rotate('+progress+'deg)',
			'-ms-transform': 'rotate('+progress+'deg)',
			'transform': 'rotate('+progress+'deg)'
		});

		return false;
	}

	if(progress <= 270) {

		uploader.find('.one').css({
			'-webkit-transform': 'rotate(90deg)',
			'-moz-transform': 'rotate(90deg)',
			'-ms-transform': 'rotate(90deg)',
			'transform': 'rotate(90deg)'
		});

		uploader.find('.two').css({
			'-webkit-transform': 'rotate(180deg)',
			'-moz-transform': 'rotate(180deg)',
			'-ms-transform': 'rotate(180deg)',
			'transform': 'rotate(180deg)'
		});

		uploader.find('.three').css({
			'-webkit-transform': 'rotate('+progress+'deg)',
			'-moz-transform': 'rotate('+progress+'deg)',
			'-ms-transform': 'rotate('+progress+'deg)',
			'transform': 'rotate('+progress+'deg)'
		});

		uploader.find('.four').css({
			'-webkit-transform': 'rotate('+progress+'deg)',
			'-moz-transform': 'rotate('+progress+'deg)',
			'-ms-transform': 'rotate('+progress+'deg)',
			'transform': 'rotate('+progress+'deg)'
		});

		return false;
	}

	if(progress <= 270) {

		uploader.find('.one').css({
			'-webkit-transform': 'rotate(90deg)',
			'-moz-transform': 'rotate(90deg)',
			'-ms-transform': 'rotate(90deg)',
			'transform': 'rotate(90deg)'
		});

		uploader.find('.two').css({
			'-webkit-transform': 'rotate(180deg)',
			'-moz-transform': 'rotate(180deg)',
			'-ms-transform': 'rotate(180deg)',
			'transform': 'rotate(180deg)'
		});

		uploader.find('.three').css({
			'-webkit-transform': 'rotate('+progress+'deg)',
			'-moz-transform': 'rotate('+progress+'deg)',
			'-ms-transform': 'rotate('+progress+'deg)',
			'transform': 'rotate('+progress+'deg)'
		});

		uploader.find('.four').css({
			'-webkit-transform': 'rotate('+progress+'deg)',
			'-moz-transform': 'rotate('+progress+'deg)',
			'-ms-transform': 'rotate('+progress+'deg)',
			'transform': 'rotate('+progress+'deg)'
		});

		return false;
	}

	if(progress <= 360) {

		uploader.find('.one').css({
			'-webkit-transform': 'rotate(90deg)',
			'-moz-transform': 'rotate(90deg)',
			'-ms-transform': 'rotate(90deg)',
			'transform': 'rotate(90deg)'
		});

		uploader.find('.two').css({
			'-webkit-transform': 'rotate(180deg)',
			'-moz-transform': 'rotate(180deg)',
			'-ms-transform': 'rotate(180deg)',
			'transform': 'rotate(180deg)'
		});
		
		uploader.find('.three').css({
			'-webkit-transform': 'rotate(270deg)',
			'-moz-transform': 'rotate(270deg)',
			'-ms-transform': 'rotate(270deg)',
			'transform': 'rotate(270deg)'
		});

		uploader.find('.four').css({
			'-webkit-transform': 'rotate('+progress+'deg)',
			'-moz-transform': 'rotate('+progress+'deg)',
			'-ms-transform': 'rotate('+progress+'deg)',
			'transform': 'rotate('+progress+'deg)'
		});

		return false;
	}
}


$('body').on('click', '.profile-pic-uploader .select-file', function() {
    var uploader = $(this).parents('.profile-pic-uploader');
    uploader.find('input[type="file"]').trigger('click');
    return false;
});

// function profileUploaderRemoveFile(uploader) {
//     uploader.find('input[name="'+uploader.attr('data-file')+'"]').val('');
//     updateProgress(uploader, 0, false);
// }

$('body').on('change', '.profile-pic-uploader input[type="file"]', function() {
	var input = $(this);
	var uploader = input.parents('.profile-pic-uploader');
    var file = input[0].files[0];
    var payload = new FormData();

    payload.append('type', uploader.attr('data-type'));
    payload.append('file', file);
    payload.append('_token', $('meta[name="csrf-token"]').attr('content'));

    // load the file into the profile image
    var reader = new FileReader();
    reader.onload = function (e) {
    	// get the base64 image data
        var imageData = e.target.result;
        uploader.find('img').attr('src', imageData);
    };
    reader.readAsDataURL(file);

    // set the progress to zero
    // uploader.removeClass('processed');
    uploader.addClass('uploading');
	updateProgress(uploader, 0, false);
    $.ajax({
		xhr: function() {
	        var xhr = new window.XMLHttpRequest();
	        xhr.upload.addEventListener('progress', function(e) {
	            if (e.lengthComputable) {
	                var percentComplete = e.loaded / e.total;
	               	percentComplete = Math.round(percentComplete * 100);
	               	console.log(percentComplete);
	               	updateProgress(uploader, percentComplete, true);
	            }
	       }, false);
	       return xhr;
	    },
		type : 'POST',
		url : uploader.attr('data-url'),
		data : payload,
		dataType : 'json',
		processData: false,
        contentType: false,
		success : function(data) {
			console.log(data);

			if(!data.success) {
				// set the progress to zero
				updateProgress(uploader, 0, false);
				showError('Error', data.message);
				return false;
			}

			// uploader.addClass('processed');
			uploader.removeClass('uploading');
			uploader.find('input[name="'+uploader.attr('data-file')+'"]').val(data.file);
			uploader.find('input[name="'+uploader.attr('data-file')+'_file"]').val(data.file_file);
		},
		error : function(request) {
			console.log(request.responseText);
		}
	});
    
    return false;
});